export default "__VITE_ASSET__D2xXQk4U__"